import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Newsletter
export const subscribeNewsletter = async (email, gdprConsent = true) => {
  const response = await api.post('/newsletter/subscribe', { email, gdpr_consent: gdprConsent });
  return response.data;
};

// Contact
export const submitContact = async (data) => {
  const response = await api.post('/contact', data);
  return response.data;
};

// Event Booking
export const bookEvent = async (data) => {
  const response = await api.post('/events/book', data);
  return response.data;
};

// Night Events
export const getNightEvents = async (category, month) => {
  const params = new URLSearchParams();
  if (category) params.append('category', category);
  if (month) params.append('month', month);
  const response = await api.get(`/night-events?${params.toString()}`);
  return response.data;
};

export const getNightEvent = async (eventId) => {
  const response = await api.get(`/night-events/${eventId}`);
  return response.data;
};

// Shop
export const getProducts = async (category) => {
  const params = category ? `?category=${category}` : '';
  const response = await api.get(`/shop/products${params}`);
  return response.data;
};

export const getProduct = async (productId) => {
  const response = await api.get(`/shop/products/${productId}`);
  return response.data;
};

export const createCheckout = async (items, customerEmail) => {
  const response = await api.post('/shop/checkout', {
    items,
    customer_email: customerEmail,
    origin_url: window.location.origin,
  });
  return response.data;
};

export const getCheckoutStatus = async (sessionId) => {
  const response = await api.get(`/shop/checkout/status/${sessionId}`);
  return response.data;
};

// Subscriptions
export const getSubscriptions = async () => {
  const response = await api.get('/subscriptions');
  return response.data;
};

export const purchaseSubscription = async (packageId, customerEmail) => {
  const response = await api.post('/subscriptions/purchase', {
    package_id: packageId,
    customer_email: customerEmail,
    origin_url: window.location.origin,
  });
  return response.data;
};

// Google Calendar
export const getGoogleAuthUrl = async () => {
  const response = await api.get('/auth/google/login', {
    params: { return_url: window.location.href }
  });
  return response.data;
};

export const getGoogleAuthStatus = async () => {
  const response = await api.get('/auth/google/status');
  return response.data;
};

export const disconnectGoogle = async () => {
  const response = await api.post('/auth/google/disconnect');
  return response.data;
};

export const getCalendarAvailability = async (startDate, endDate) => {
  const params = new URLSearchParams();
  if (startDate) params.append('start_date', startDate);
  if (endDate) params.append('end_date', endDate);
  const response = await api.get(`/calendar/availability?${params.toString()}`);
  return response.data;
};

// Nexi Payments
export const createNexiCheckout = async (orderId, amount, description, customerEmail, customerName, productType, items = [], couponCode = null) => {
  const response = await api.post('/nexi/checkout', {
    order_id: orderId,
    amount: amount, // in cents
    description: description,
    customer_email: customerEmail,
    customer_name: customerName,
    product_type: productType,
    items: items,
    coupon_code: couponCode
  });
  return response.data;
};

export const verifyNexiPayment = async (orderId) => {
  const response = await api.get(`/nexi/verify/${orderId}`);
  return response.data;
};

// Coupon System
export const validateCoupon = async (code, originalAmount) => {
  const response = await api.post('/coupon/validate', {
    code: code,
    original_amount: originalAmount
  });
  return response.data;
};

export default api;
